import { Component, Fragment, h, Prop } from '@stencil/core';
import { iconBancontact, iconCreditCard, iconIdeal, iconPP, iconPPP, iconSepa, iconSofort } from '../icons';
import { t } from '../../../redux/utils';
import { PaymentMethod } from '../../../redux/types';
import { PaymentOption } from '../utils/types';
import { SelectOption } from '../../../types/types';

@Component({
  tag: 'rtr-payment-options-order',
  styleUrl: '../style.sass',
  shadow: false,
})
export class RtrPaymentOptionsOrder {
  @Prop() paymentOptions: SelectOption[];
  @Prop() currentMethod: PaymentMethod;
  @Prop() onOptionChange: (item: SelectOption) => void;
  @Prop() onShowChangeMethod;
  @Prop() showPaymentOptions;
  @Prop() allowChange: boolean;
  @Prop() optionsError: boolean;

  private optionsEl: HTMLDivElement;

  componentDidUpdate() {
    if (!this.currentMethod && this.paymentOptions?.length === 1) {
      this.onOptionChange(this.paymentOptions[0]);
    }
    if (this.optionsError) {
      this.optionsEl?.scrollIntoView({ behavior: 'smooth' });
    }
  }

  get optionsClass() {
    if (this.optionsError) {
      return 'RTPOptionError';
    }

    return '';
  }

  get showChooseText(): boolean {
    return this.paymentOptions?.length > 1;
  }

  get methodTitleText(): string {
    return t('payment.paymentMethod');
  }

  get changeMethodText(): string {
    return t('payment.changeMethod');
  }

  mappedPaymentOption = item => {
    // excluded from order
    if ([PaymentOption.Reservation, PaymentOption.Prepayment, PaymentOption.GiftCard, PaymentOption.StripeExpressCheckout, PaymentOption.PayPalCheckout].includes(item.value)) {
      return;
    }

    const label = item.value !== PaymentOption.PayPalPlus ? item.label : ' ';

    const onRadioClick = (e: Event) => {
      e?.preventDefault();
      this.onOptionChange(item);
    };

    return (
      <label class={'RTPItemLabelContainerOrder ' + item.value}>
        <rentware-radio
          name='paymentMethodOption'
          label={label}
          value={item.value}
          checked={this.currentMethod && this.currentMethod.value === item.value}
          onClick={onRadioClick}
        />

        <div class='RTPSVGContainer'>
          {item.value === PaymentOption.PayPal && iconPP()}
          {item.value === PaymentOption.PayPalPlus && iconPPP()}
          {item.value === PaymentOption.StripeIdeal && iconIdeal()}
          {item.value === PaymentOption.StripeCC && iconCreditCard()}
          {item.value === PaymentOption.StripeSepa && iconSepa()}
          {item.value === PaymentOption.StripeSofort && iconSofort()}
          {item.value === PaymentOption.StripeBanContact && iconBancontact()}
        </div>
      </label>
    );
  };

  render() {
    const currentLabel = this.currentMethod?.value !== PaymentOption.PayPalPlus ? this.currentMethod?.label : iconPPP();
    return (
      <Fragment>
        <div class='RTPOptionsTitle' id='Method'>
          {this.methodTitleText}
        </div>

        <rentware-spacer size='S' />

        {(this.showPaymentOptions && (
          <div
            class={this.optionsClass}
            ref={el => {
              this.optionsEl = el;
            }}
          >
            {this.paymentOptions.map(this.mappedPaymentOption)}
          </div>
        )) || (
          <div
            class={this.optionsClass}
            ref={el => {
              this.optionsEl = el;
            }}
          >
            <div class='RTPOnePaymentContainer RTPOrder'>
              <div class='SelectedMethodText'>
                <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                  <rect width='20' height='20' rx='10' fill='#46435B' />
                  <rect x='8' y='8' width='4' height='4' rx='2' fill='white' />
                </svg>

                {currentLabel}
              </div>

              {this.allowChange && this.showChooseText && (
                <div class='ChangeMethodLink' onClick={this.onShowChangeMethod}>
                  {this.changeMethodText}
                </div>
              )}
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}
